import Cookie from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { setConsent } from 'store/actions/consent';

const cookieName = 'CookieConsent';

export const setConsentCookie = (consent) => Cookie.set(cookieName, consent, { expires: 365 });

export const getConsentCookie = () => {
    try {
        return JSON.parse(Cookie.get(cookieName));
    } catch(error) {
        return null;
    }
};

export default function useCookieConsent() {
    const dispatch = useDispatch();
    const { consent } = useSelector(state => state.cookies);

    const setCookieConsent = (givenConsent) => {
        dispatch(setConsent(givenConsent));
    };

    return [ consent, setCookieConsent ];
}
